import { useEffect, useRef } from "react";
import { InamdarHospiLogo } from "../../assets/printAssets/InmadarHospiLogo";
import { GeneratePrint } from "../../common/components/printModal/GeneratePrint";

const ABGAnalysisPrint = (props) => {
  const { patientInfo, ABGParametersList } = props;
  const printRef = useRef(null);

  useEffect(() => {
    printRef && GeneratePrint(printRef);
  }, []);
  return (
    <div ref={printRef}>
      <div className="grid grid-cols-6 relative">
        <div className="grid justify-end col-span-4 text-center">
          <h1 className="text-[15px] font-semibold">
CIMET's Inamdar Multispeciality Hospital             </h1>
          <h1 className="text-[11px]">
            Sr. No 15, Fatimanagar, Behind Kpct Mall Pune - 411 040
          </h1>
          <h1 className="text-[14px] font-semibold">
            Phone No : 020-66812222/44
          </h1>
        </div>
        <div className="absolute right-0 -top-10 col-span-2">
          <InamdarHospiLogo />
        </div>
      </div>
      <div className="grid grid-cols-3 border-black border-b-[1px] border-t-[1px] pb-[2px] text-[12px]">
        <div className="flex col-span-2">
          <span className="font-bold w-28">Patient Name&nbsp;</span>
          <span>: {patientInfo?.["PatientName"]}</span>
        </div>
        <div className="flex">
          <span className="font-bold w-16">MR No.&nbsp;</span>
          <span>: {patientInfo?.MRNo}</span>
        </div>
        <div className="flex col-span-2">
          <span className="font-bold w-28">Age&nbsp;</span>
          <span>: {patientInfo?.AgeYear}</span>
        </div>
        <div className="flex">
          <span className="font-bold w-16">Gender&nbsp;</span>
          <span className="flex gap-2 items-center">
            : {patientInfo?.Gender}
          </span>
        </div>
      </div>
      <div className="text-center text-[15px] font-semibold py-[2px]">
        ABG Result
      </div>
      <table className="border border-collapse border-black w-full text-[12px]">
        <tr>
          <th className="border border-collapse border-black">
            Parameter Name
          </th>
          <th className="border border-collapse border-black">
            Parameter Value
          </th>
          <th className="border border-collapse border-black">Normal Range</th>
        </tr>
        {ABGParametersList?.map((val) => {
          return (
            <tr className="text-center">
              <td className="border border-collapse border-black">
                {val?.["Parameter Name"]}
              </td>
              <td className="border border-collapse border-black">
                {val?.["Parameter Value"]}
              </td>
              <td className="border border-collapse border-black">
                {val?.["Normal Range"]}
              </td>
            </tr>
          );
        })}
      </table>
    </div>
  );
};

export default ABGAnalysisPrint;
